import React from "react"

import PdfPreview from "../components/pdf-preview/pdf-preview"
import * as pdfData from "../../static/diagnosis/diagnosis.pdf"

class DiagnozyPage extends React.Component {

  render() {
    return (
      <PdfPreview pdfData={pdfData}></PdfPreview>
    )
  }
}

export default DiagnozyPage